import axios from "axios";
import forge from "node-forge";
import { config } from "./config";

class APIClient {
  get(url) {
    return axios.get(url);
  }

  register({ key: recaptchaSiteKey, captcha, noq, ...data }) {
    console.log(data);
    const _data = encodeURIComponent(JSON.stringify(data));

    const key = forge.random.getBytesSync(32);
    const iv = forge.random.getBytesSync(16);
    const cipher = forge.cipher.createCipher("AES-CBC", key);
    cipher.start({ iv: iv });
    cipher.update(forge.util.createBuffer(_data));
    cipher.finish();
    const encrypted = cipher.output;
    const encryptedData = forge.util.encode64(encrypted.bytes());

    const hmac = forge.hmac.create();
    hmac.start("sha256", key);
    hmac.update(forge.util.encode64(encrypted.bytes()));
    const signature = hmac.digest().toHex();

    const pub2 = forge.pki.publicKeyFromPem(config.key);

    const body = {
      key: forge.util.encode64(pub2.encrypt(key, "RSA-OAEP")),
      salt: forge.util.encode64(iv),
      signature,
      noq,
      data: encryptedData,
      recaptchaToken: captcha,
      recaptchaSiteKey
    };
    return axios.post(config.endpoint, body);
  }
}

class DummyClient {
  get(url) {
    if (url === "success") {
      return new Promise((resolve, reject) => {
        resolve({
          data: {
            messageId: "0000",
            ticketNumber: "A99999",
            qrcode: "A99999"
          }
        });
      });
    } else if (url === "duplicate") {
      return new Promise((resolve, reject) => {
        resolve({
          data: {
            messageId: "8888",
            ticketNumber: "A99999",
            qrcode: "A99999"
          }
        });
      });
    } else if (url === "nomore") {
      return new Promise((resolve, reject) => {
        resolve({
          data: {
            code: 410
          }
        });
      });
    } else {
      return new Promise((resolve, reject) => {
        reject(Error("err error"));
      });
    }
  }

  register({ key: recaptchaSiteKey, captcha, product, email, ...data }) {
    if (email === "success@noq.com.hk") {
      return new Promise((resolve, reject) => {
        resolve({
          data: {
            messageId: "0000",
            success: "success",
            fail: "fail"
          }
        });
      });
    } else if (email === "duplicate@noq.com.hk") {
      return new Promise((resolve, reject) => {
        resolve({
          data: {
            messageId: "0000",
            success: "duplicate",
            fail: "fail"
          }
        });
      });
    } else {
      return new Promise((resolve, reject) => {
        resolve({
          data: {
            messageId: "0000",
            success: "fail",
            fail: "nomore"
          }
        });
      });
    }
  }
}

const client =
  process.env.REACT_APP_MODE === "rehearsal"
    ? new DummyClient()
    : new APIClient();
export default client;
